// أدوات عامة: التنسيق، التواريخ، الهروب من HTML.

export const DAY_MS = 86400000;

export const MONTHS = ['كانون الثاني','شباط','آذار','نيسان','أيار','حزيران',
                       'تموز','آب','أيلول','تشرين الأول','تشرين الثاني','كانون الأول'];
export const WDAYS = ['الأحد','الاثنين','الثلاثاء','الأربعاء','الخميس','الجمعة','السبت'];

/** يهرب من الرموز الخطرة — ضروري لأن أسماء الوجهات والأنواع يكتبها المستخدم. */
export function esc(s){
  return String(s == null ? '' : s)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

/** للمجاميع والتقارير: أعداد صحيحة — الكسور ضجيج في رقم مجمّع. */
export function fmt(n){
  return Math.round(Number(n) || 0).toLocaleString('en-US');
}

/**
 * لمبلغ حركة مفردة: يُظهر المنزلتين حين توجد كسور فقط.
 * استخدام fmt هنا يعرض 7.50 كـ«8» — وهو تحريف لمبلغ أدخله المستخدم بنفسه،
 * بعكس التقريب في مجموع مئات الحركات حيث لا يغيّر شيئاً.
 */
export function money(n){
  const v = Number(n) || 0;
  const rounded = Math.round(v * 100) / 100;
  const hasFraction = Math.abs(rounded % 1) > 0;
  return rounded.toLocaleString('en-US', {
    minimumFractionDigits: hasFraction ? 2 : 0,
    maximumFractionDigits: 2
  });
}

export function pad2(n){ return (n < 10 ? '0' : '') + n; }

/** بداية اليوم بالتوقيت المحلي. */
export function startOfDay(ts){
  const d = new Date(ts); d.setHours(0, 0, 0, 0); return d.getTime();
}
export function endOfDay(ts){ return startOfDay(ts) + DAY_MS - 1; }

export function ymd(ts){
  const d = new Date(ts);
  return d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate());
}
export function fromYmd(s){
  const p = String(s).split('-');
  if (p.length !== 3) return null;
  const t = new Date(+p[0], +p[1] - 1, +p[2]).getTime();
  return isNaN(t) ? null : t;
}

export function sameDay(a, b){
  return startOfDay(a) === startOfDay(b);
}

export function dayLabel(ts, now = Date.now()){
  if (sameDay(ts, now)) return 'اليوم';
  if (sameDay(ts, now - DAY_MS)) return 'أمس';
  const d = new Date(ts);
  const y = new Date(now).getFullYear() !== d.getFullYear() ? ' ' + d.getFullYear() : '';
  return WDAYS[d.getDay()] + ' ' + d.getDate() + ' ' + MONTHS[d.getMonth()] + y;
}

export function shortDate(ts){
  const d = new Date(ts);
  return d.getDate() + ' ' + MONTHS[d.getMonth()];
}

export function timeLabel(ts){
  const d = new Date(ts), h = d.getHours(), m = d.getMinutes();
  const ap = h < 12 ? 'ص' : 'م';
  const hh = h % 12 || 12;
  return hh + ':' + pad2(m) + ' ' + ap;
}

/** بداية شهر مزاح بمقدار offset شهراً للخلف. */
export function monthStart(ts, offset = 0){
  const d = new Date(ts);
  return new Date(d.getFullYear(), d.getMonth() - offset, 1).getTime();
}

export function daysInMonth(ts){
  const d = new Date(ts);
  return new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
}

/* أُزيلت pressDigit — حلّ محلّها محرّك الحاسبة في calc.js،
   الذي يدعم الكسور والعمليات الحسابية بأولوية صحيحة. */

export function clamp(n, lo, hi){ return Math.min(hi, Math.max(lo, n)); }

/** تأخير التنفيذ — يُستخدم لحفظ التخزين دون إثقال كل ضغطة. */
export function debounce(fn, ms){
  let t = null;
  return function(...args){
    clearTimeout(t);
    t = setTimeout(() => fn.apply(null, args), ms);
  };
}
